<div class="footer-holder">
  <div class="copyright">&copy; 2026 - INOBU AB</div>
</div>
